import { AuthenticatorApi } from "./AuthenticatorApi";
import { DMAPolicyEvaluatorApi } from "./DMAPolicyEvaluatorApi";
import { FeedModelApi } from "./FeedModelApi";
import { HeaderStorageApi } from "./HeaderStorageApi";
import { PackageStateApi } from "./PackageStateApi";
import { ViewChangedApi } from "./ViewChangedApi";
import { WidgetBadge } from "./WidgetBadge";
import { WidgetGeolocationApi } from "./WidgetGeolocationApi";
import { WidgetLocaleTime } from "./WidgetLocaleTime";
import { WidgetModelApi } from "./WidgetModelApi";
import { WidgetPinningApi } from "./WidgetPinningApi";
import { WidgetRendererApi } from "./WidgetRendererApi";
import { WidgetShellFeeds } from "./WidgetShellFeeds";
import { WidgetSignalApi } from "./WidgetSignalApi";
import { WidgetTelemetryApi } from "./WidgetTelemetryApi";
import { WidgetUserInfo } from "./WidgetUserInfo";
import { WidgetWindowPin } from "./WidgetWindowPin";
import { WidgetWindowView } from "./WidgetWindowView";
import { getWidgetComponentApiInstance } from "./_widgetComponentApiInstance";
import { WidgetCommandApi } from "./WidgetCommandApi";
export class WidgetModelApiFactory {
    // Construct the vactory with velocity so that it is avalable to other components being initalized
    constructor(velocityApi) {
        this._apiObjects = new Map();
        this._apiObjects.set("velocity", velocityApi);
    }
    async initializeAsync(orchestratorFactory) {
        var _a, _b, _c, _d, _e;
        // API names here should be all lowercase, because tryGetApi converts everything to lowercase.
        this._apiObjects.set("model", new WidgetModelApi(orchestratorFactory));
        this._apiObjects.set("renderer", new WidgetRendererApi());
        this._apiObjects.set("geolocation", new WidgetGeolocationApi());
        this._apiObjects.set("telemetry", new WidgetTelemetryApi());
        this._apiObjects.set("signals", new WidgetSignalApi());
        this._apiObjects.set("widgetbadge", new WidgetBadge());
        this._apiObjects.set("widgetshellfeeds", new WidgetShellFeeds());
        this._apiObjects.set("widgetlocaletime", new WidgetLocaleTime());
        this._apiObjects.set("widgetwindowview", new WidgetWindowView());
        this._apiObjects.set("widgetuserinfo", new WidgetUserInfo());
        this._apiObjects.set("widgetcomponentapi", getWidgetComponentApiInstance());
        this._apiObjects.set("viewchanged", new ViewChangedApi());
        this._apiObjects.set("authenticator", new AuthenticatorApi());
        this._apiObjects.set("widgetwindowpin", new WidgetWindowPin());
        this._apiObjects.set("dmapolicyevaluator", new DMAPolicyEvaluatorApi());
        this._apiObjects.set("feedsmodel", new FeedModelApi());
        this._apiObjects.set("packagestate", new PackageStateApi());
        this._apiObjects.set("widgetpinning", new WidgetPinningApi());
        this._apiObjects.set("commands", new WidgetCommandApi());
        this._apiObjects.set("headerstorage", new HeaderStorageApi());
        // Do any async init required here
        await Promise.all([
            (_a = this.tryGetApi("geolocation", 1, 1)) === null || _a === void 0 ? void 0 : _a.initialize(),
            (_b = this.tryGetApi("authenticator", 1, 1)) === null || _b === void 0 ? void 0 : _b.initialize(),
            (_c = this.tryGetApi("packagestate", 1, 1)) === null || _c === void 0 ? void 0 : _c.initialize(),
            (_d = this.tryGetApi("feedsmodel", 1, 1)) === null || _d === void 0 ? void 0 : _d.initializeAsync(),
            (_e = this.tryGetApi("commands", 1, 1)) === null || _e === void 0 ? void 0 : _e.initialize(),
        ]);
    }
    // FUTURE: pattern to store/get versioned apis...
    // Principals:
    //  A) Changes to the api should endeavor to be backwards compatible
    //  B) Callers are expected to test the existence of apis
    //  Any change that invalidates (A) will require implementing a version api mechanism
    tryGetApi(apiName, minVersion, targetVersion) {
        if (this._apiObjects.has(apiName.toLowerCase())) {
            return this._apiObjects.get(apiName);
        }
        return null;
    }
}
